import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getConsent, hasConsentPlatform, saveConsent, useConsent } from "../lib/consent";
import { useI18n } from "../i18n";
import { withLang } from "../i18n/paths";

// Asks once which optional cookies are OK. Saying no is as easy as saying yes,
// and "Cookie settings" in the footer brings it back.
export default function CookieBanner() {
  const { t, tx, lang } = useI18n();
  const { consent, open, setOpen } = useConsent();
  const [choosing, setChoosing] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [ads, setAds] = useState(false);
  // A moment's wait lets a consent platform (if one is set up) take over instead.
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setReady(true), 1200);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (!open) return;
    const c = getConsent();
    setAnalytics(!!c?.analytics);
    setAds(!!c?.ads);
    setChoosing(true);
  }, [open]);

  const show = open || (ready && !consent && !hasConsentPlatform());
  if (!show) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-labelledby="cookie-title" aria-live="polite">
      <div className="cookie-card">
        <h2 id="cookie-title">{t("Cookies?")}</h2>
        <p>
          {tx(
            "We use a few essential cookies and storage to run the games and keep you signed in. With your OK we'd also use <b>Google Analytics</b> to see which games people enjoy, and <b>Google ads cookies</b> to show more relevant ads. See our <link>Privacy Policy</link>.",
            {},
            {
              link: (c, k) => (
                <Link key={k} to={withLang(lang, "/privacy") + "#cookies"} onClick={() => setOpen(false)}>
                  {c}
                </Link>
              ),
            }
          )}
        </p>
        {choosing && (
          <div className="cookie-options">
            <label className="cookie-option">
              <input type="checkbox" checked disabled />
              <span>
                <b>{t("Essential")}</b>
                <small>{t("Sign-in, your guest name, sound on/off, this choice. Always on.")}</small>
              </span>
            </label>
            <label className="cookie-option">
              <input type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} />
              <span>
                <b>{t("Analytics")}</b>
                <small>{t("Google Analytics: stats on which pages and games get used, so we can improve them.")}</small>
              </span>
            </label>
            <label className="cookie-option">
              <input type="checkbox" checked={ads} onChange={(e) => setAds(e.target.checked)} />
              <span>
                <b>{t("Personalised ads")}</b>
                <small>{t("Google AdSense may use cookies to pick ads for you. Without this you still see a few basic ads.")}</small>
              </span>
            </label>
          </div>
        )}
        <div className="cookie-actions">
          {choosing ? (
            <button className="btn btn-primary" onClick={() => saveConsent({ analytics, ads })}>
              {t("Save my choices")}
            </button>
          ) : (
            <>
              <button className="btn btn-primary" onClick={() => saveConsent({ analytics: true, ads: true })}>
                {t("Accept all")}
              </button>
              <button className="btn btn-primary" onClick={() => saveConsent({ analytics: false, ads: false })}>
                {t("Only essential")}
              </button>
              <button className="btn btn-ghost" onClick={() => setChoosing(true)}>
                {t("Choose…")}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
